(function($) {
  if (!$ || !$.datepicker) {
    return;
  }

  $(document).on('keydown', '.gform-datepicker', function(e) {
    var inst = $.datepicker._getInst(this);
    if (!inst || !$.datepicker._datepickerShowing) {
      return;
    }

    var handled = true;

    switch (e.keyCode) {
      case 37: // Left - previous day
        $.datepicker._adjustDate(this, -1, 'D');
        break;
      case 38: // Up - previous week
        $.datepicker._adjustDate(this, -7, 'D');
        break;
      case 39: // Right - next day
        $.datepicker._adjustDate(this, 1, 'D');
        break;
      case 40: // Down - next week
        $.datepicker._adjustDate(this, 7, 'D');
        break;
      default:
        handled = false;
    }

    if (handled) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  });
})(jQuery);
